import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { QueryProvider } from "@/app/providers/QueryProvider";
import { ThemeProvider } from "@/app/providers/ThemeProvider";
import { AuthProvider } from "@/app/providers/AuthProvider";
import { AppRouter } from "@/router";
import { Toaster } from "@/components/ui/toast";
import { BackgroundJobsTray } from "@/components/common/BackgroundJobsTray";
import { ErrorBoundary } from "@/components/common/ErrorBoundary";

// Order matters. AuthProvider calls useNavigate, so it must sit inside
// BrowserRouter, and it uses the query client to clear caches on sign-out, so
// it must sit inside QueryProvider.
export default function App() {
  // The browser tab title itself lives in index.html's own <title> tag,
  // which isn't part of this src/ tree -- set it here too as a safety net
  // so the tab reads "Work4HR" regardless, and so a future per-page title
  // (e.g. "Employees · Work4HR") has a single place to build on rather
  // than every page needing its own document.title write.
  useEffect(() => {
    document.title = "Work4HR";
  }, []);

  return (
    <ErrorBoundary>
      <QueryProvider>
        <ThemeProvider>
          <BrowserRouter>
            <AuthProvider>
              <AppRouter />
              <Toaster />
              <BackgroundJobsTray />
            </AuthProvider>
          </BrowserRouter>
        </ThemeProvider>
      </QueryProvider>
    </ErrorBoundary>
  );
}
